import React, { useLayoutEffect, useState, useCallback } from 'react'
import FilterGroup from './filter_group.jsx'
import { RangeInput } from 'lensrentals-components'
import useDebouncedCallback from '../misc/use_debounced_callback.jsx'
import styles from '../../assets/stylesheets/pages/searches/filters.module.scss'
import PropTypes from 'prop-types'

const AtLeastSliderFilter = props => {
  const {
    name,
    values,
    filterType,
    selectAtLeastFilter,
    selectedFilters,
    handleFilterSelection,
    isOpen,
    toggleOpenFilters,
    isExpanded,
    toggleExpandedFilters
  } = props

  const selectAtLeastFilterDebounced = useDebouncedCallback(
    (selectedFilters, name, adjustedMinValue, adjustedMaxVal, event) => handleFilterSelection(selectAtLeastFilter(selectedFilters, name, adjustedMinValue, adjustedMaxVal), event),
    500
  )
  const sortedValues = values.sort((a, b) => a - b)

  const [index, setIndex] = useState(null)

  const onChangeSliderFilter = useCallback((event) => {
    if (event.target.value) {
      event.persist()
      const selectedIndex = parseFloat(event.target.value)
      setIndex(selectedIndex)
      selectAtLeastFilterDebounced(selectedFilters, name, parseFloat(sortedValues[0]), parseFloat(sortedValues[selectedIndex]), event)
    }
  }, [name, selectAtLeastFilterDebounced, selectedFilters, sortedValues])

  useLayoutEffect(() => {
    if (selectedFilters) {
      const currentSelectedFilters = JSON.parse(selectedFilters)
      let existingFilter = null
      if (currentSelectedFilters[filterType]) {
        existingFilter = currentSelectedFilters[filterType].find(filter => filter.name === `${name}`)
      }
      if (existingFilter && existingFilter.lte > 0) {
        const currentMaxVal = parseFloat(existingFilter.lte)
        let currentIndex = sortedValues.indexOf(currentMaxVal)
        if (currentIndex === -1) {
          // try next closest value
          currentIndex = sortedValues.findIndex(val => val > currentMaxVal)
          if (currentIndex === -1) {
            currentIndex = sortedValues.findIndex(val => val < currentMaxVal)
            if (currentIndex === -1) {
              setIndex(null)
            } else {
              setIndex(currentIndex)
            }
          }
        } else {
          setIndex(currentIndex)
        }
      } else {
        setIndex(null)
      }
    }
  }, [selectedFilters, filterType, name, sortedValues])

  return (
    <FilterGroup
      name={name}
      isOpen={isOpen}
      toggleOpenFilters={toggleOpenFilters}
      isExpanded={isExpanded}
      toggleExpandedFilters={toggleExpandedFilters}
    >
      <RangeInput
        at-least
        className={styles['filter--slider']}
        key={`${name}-${name}`}
        id={name.replace(/\s+/g, '-')}
        min={0}
        max={sortedValues.length - 1}
        value={index}
        onClick={values.length === 1 ? onChangeSliderFilter : null}
        onChange={onChangeSliderFilter}
      />
      {index !== null &&
        <span className={`${name.replace(/\s+/g, '-')}-span`}>
          {`At least f/${sortedValues[index]}`}
        </span>}
    </FilterGroup>
  )
}

AtLeastSliderFilter.propTypes = {
  name: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  filterType: PropTypes.string.isRequired,
  selectAtLeastFilter: PropTypes.func.isRequired,
  selectedFilters: PropTypes.string.isRequired,
  handleFilterSelection: PropTypes.func.isRequired
}

export default AtLeastSliderFilter
